/**
 * Web Style Import
 *
 */

import './style/dnb-section.scss'
